import React from 'react'
import classNames from 'classnames'
import Link from 'lib/struct/Link'
import List from 'lib/struct/List'
import MainHeader from 'lib/struct/MainHeader'
import svg from '../img/bodysite-logo.svg';
import telegram from '../img/telegram.svg';
import youtube from '../img/youtube.svg';
import vk from '../img/vk.svg';
import styles from './styles.less'

export default class Header extends React.PureComponent {
    render() {
        return (
            <div className={styles['header-bar']}>
                <div className={styles['header-bar__info']}>
                    <MainHeader className={styles['header']}>Интеграция с Яндекс.Маркет
                        <span className={styles['header__plugin-version']}>v.&nbsp;{window.shop_pokupki_plugin_version}</span>
                    </MainHeader>
                    <div className={styles['dev-block']}>
                        <div className={styles['dev-block__item']}>
                            <span className={styles['dev-block__label']}>Разработчик:</span>
                            <Link href="https://bodysite.ru"
                                  target="_blank"
                                  className={styles['dev-block__icon-link']}>
                                <img className={styles['bodysite-logo']}
                                     src={`${window.shop_pokupki_base_url}assets/${svg}`}/>
                            </Link>
                        </div>
                        <div className={styles['dev-block__item']}>
                            <span className={styles['dev-block__label']}>Подписывайтесь:</span>
                            <Link href="https://t.me/bodysite"
                                  target="_blank"
                                  className={styles['dev-block__icon-link']}>
                                <img className={classNames(styles['dev-block__icon'], styles['icon24'])} src={`${window.shop_pokupki_base_url}assets/${telegram}`}/>
                            </Link>
                            <Link href="https://www.youtube.com/channel/UCbPi3dch9M-lInwPiO4aMEQ"
                                  target="_blank" className={styles['dev-block__icon-link']}>
                                <img className={classNames(styles['dev-block__icon'], styles['icon24'])} src={`${window.shop_pokupki_base_url}assets/${youtube}`}/>
                            </Link>
                            <Link href="https://vk.com/bodysiteofficial"
                                  target="_blank" className={styles['dev-block__icon-link']}>
                                <img className={classNames(styles['dev-block__icon'], styles['icon24'], styles['dev-block__icon_last'])} src={`${window.shop_pokupki_base_url}assets/${vk}`}/>
                            </Link>
                        </div>
                    </div>
                </div>
                <div className={styles['link-bar']}>
                    <List className={styles['link-bar__list']} isHorizontal>
                        <Link href="https://bodysite.ru/help/pokupki/manual/"
                              target="_blank"
                              icon={<span className={classNames(styles['icon16'], styles['help-icon'])}/>}
                              className={styles['link-bar__link']}>
                            Инструкции по настройке
                        </Link>
                        <Link href="https://bodysite.ru/help/pokupki/reports/"
                              target="_blank"
                              icon={<span className={classNames(styles['icon16'], styles['support-icon'])}/>}
                              className={styles['link-bar__link']}>
                            Сообщить об ошибке
                        </Link>
                        <Link href="https://bodysite.ru/help/pokupki/suggestions/"
                              target="_blank"
                              icon={<span className={classNames(styles['icon16'], styles['bulb-icon'])}/>}
                              className={styles['link-bar__link']}>
                            Предложить улучшение
                        </Link>
                        <Link href="https://www.webasyst.ru/store/plugin/shop/pokupki/reviews/"
                              target="_blank"
                              icon={<span className={classNames(styles['icon16'], styles['review-icon'])}/>}
                              className={styles['link-bar__link']}>
                            Оставить отзыв
                        </Link>
                    </List>
                </div>
            </div>
        );
    }
}